import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMonth } from "src/models/General/Month.models";

interface MonthState {
  months: IMonth[];
  monthToEdit: IMonth | null;
}

const initialState: MonthState = {
  months: [],
  monthToEdit: null,
};

const monthSlice = createSlice({
  name: "Month",
  initialState,
  reducers: {
    setMonthList: (state, action: PayloadAction<IMonth[]>) => {
      state.months = action.payload;
    },
    concatListMonth: (state: MonthState, action: PayloadAction<IMonth[]>) => {
      state.months = [...state.months.concat(action.payload)];
    },
    setMonthToEdit: (state, action: PayloadAction<IMonth | null>) => {
      state.monthToEdit = action.payload;
    },
    addMonth: (state, action: PayloadAction<IMonth>) => {
      state.months.push(action.payload);
    },
    updateMonth: (state, action: PayloadAction<IMonth>) => {
      let itemIndex = state.months.findIndex(
        item => item.monthId === action.payload.monthId
      );
      if (itemIndex !== -1) state.months[itemIndex] = action.payload;
    },
    deleteMonth: (state, action: PayloadAction<number>) => {
      const newArray = state.months.filter(
        item => item.monthId !== action.payload
      );
      state.months = newArray;
    },
  },
});

export const {
  setMonthList,
  concatListMonth,
  setMonthToEdit,
  addMonth,
  updateMonth,
  deleteMonth,
} = monthSlice.actions;

export default monthSlice.reducer;
